<template>
  <div class="vue-select-town-dropdown-wrap">
    <div>
        <select @change="onTownSelectChange($event)" name="utilites">
          <option v-for="town in townsForDropdown" v-bind:selected="town.selected" :key="town.townId" :value="town.townId">{{town.name}}</option>
        </select>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash';

export default {
  name: 'SelectTownDropdown',
  props: {
      towns: Array,
      townSelected: Function
  },
  data() {
    return {
      placeholderTownId: 999,
      townsForDropdown: undefined
    }
  },
  async created() {
    this.processTownsForDropdown(this.towns);
  },
  watch: {
    towns: function (towns) {
      this.processTownsForDropdown(towns);
    }
  },
  methods: {
    onTownSelectChange(event) {
      const townId = parseInt(event.target.value, 10);
      const matchingTown = lodash.find(this.townsForDropdown, town => town.townId === townId);
      if (matchingTown.townId === this.placeholderTownId) {return; }
      this.townSelected(matchingTown);
    },
    processTownsForDropdown(towns) {
      this.townsForDropdown = JSON.parse(JSON.stringify(towns));

      this.townsForDropdown.unshift({
        townId: this.placeholderTownId,
        name: 'Please select a town',
        selected: true
      });
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
